import React, { useMemo } from 'react';
import ManCrossIcpTrendChart from '../../graphics/managerialCross/ManCrossIcpTrendChart';
import ManCrossIcpCurrentCard from '../components/ManCrossIcpCurrentCard';
import ManCrossPageFooter from '../components/ManCrossPageFooter';

const ManCrossPageIcpTrend = ({ reportData, headerText, pageNumber }) => {
    const payload = reportData?.payload || {};

    // Datos del backend — Spec S22 §1.4
    const tendenciaRaw = payload.tendencia_ICP || [];
    const mesMeta      = payload.mes_meta      || 'en más de 2 años';
    const aniosRiesgo  = payload.anios_riesgo  ?? 2;

    // Adaptar al formato que espera ManCrossIcpTrendChart: {period, value, isProjected}
    const chartData = useMemo(() =>
        tendenciaRaw.map((item) => ({
            period:      item.periodo,
            value:       Number.isFinite(Number(item.icp)) ? Number(item.icp) : 0,
            isProjected: item.tipo === 'proyectado',
        })),
    [tendenciaRaw]);

    // KPI: último período real
    const currentIcp = useMemo(() => {
        const historical = chartData.filter((d) => !d.isProjected);
        return historical.length > 0
            ? historical[historical.length - 1].value
            : (chartData[0]?.value ?? 0);
    }, [chartData]);

    return (
        <div className="mgcr-drivers-page">
            <div className="mgcr-page-header">
                <span className="mgcr-page-header-text">{headerText}</span>
                <span className="mgcr-page-header-num">{pageNumber}</span>
            </div>

            <div className="keep-blankspace" />

            <div className="mgcr-dx-title-area">
                <h2 className="mgcr-dx-main-title">Tendencia ICP</h2>
                <p className="mgcr-dx-subtitle">Aceleración de Meta</p>
            </div>

            <div className="mgcr-icp-trend-hero">
                <div className="mgcr-icp-trend-kpi-panel">
                    <ManCrossIcpCurrentCard value={currentIcp} />
                </div>
                <div className="mgcr-icp-trend-chart-panel">
                    <ManCrossIcpTrendChart data={chartData} />
                </div>
            </div>

            <div className="mgcr-insight-footer">
                Cada punto de ICP no alcanzado antes de{' '}
                <span style={{ fontWeight: 600 }}>{mesMeta}</span> es un riesgo que permanece
                activo durante{' '}
                <span style={{ fontWeight: 600 }}>{aniosRiesgo} años</span>.
            </div>

            <div className="keep-blankspace" />
            <ManCrossPageFooter />
        </div>
    );
};

export default ManCrossPageIcpTrend;

